export const en = {
    share: {
        loading: 'Loading shared photo...',
        unavailableTitle: 'Link not available',
        unavailableMessage: 'This link is no longer available. It may have been removed by its owner.',
        tagged: 'Tagged as',
    },
    header: {
        title: 'Family Moments',
        toggleFilters: 'Toggle filters',
        upload: 'Upload photos',
        lightMode: 'Switch to light',
        darkMode: 'Switch to dark',
        moreOptions: 'More options',
        settings: 'Settings',
        logout: 'Logout',
    },
    dashboard: {
        loadingMemories: 'Loading your memories...',
        noPhotos: 'No photos yet. Upload your first memory!',
        noPhotosFiltered: 'No photos match your filters.',
        toggleThemeLight: 'Light Mode',
        toggleThemeDark: 'Dark Mode',
        user: 'User',
    },
    sidebar: {
        people: 'People',
        noPeopleTagged: 'No people tagged yet',
        places: 'Places',
        noPlacesTagged: 'No places tagged yet',
        years: 'Years',
        noYearsTagged: 'No years tagged yet',
        events: 'Events',
        noEventsTagged: 'No events tagged yet',
        visibility: 'Visibility',
        all: 'All',
        public: 'Public',
        private: 'Private',
        resetAllFilters: 'Reset All Filters',
        resetIcon: 'Reset All Filters',
        showMore: 'Show more',
        showLess: 'Show less',
        searchPlaceholder: 'Search tags...',
        noMatchesFound: 'No matches found',
    },
    dock: {
        all: 'All',
        clear: 'Clear',
        clearAllFilters: 'Clear all filters',
        allPhotos: 'All photos',
        loading: 'Loading...',
    },
    settings: {
        title: 'Settings',
        theme: 'Theme',
        light: 'Light',
        dark: 'Dark',
        language: 'Language',
    },
    upload: {
        title: 'Upload Photos',
        dragDropText: 'Drag & drop photos here or click to select',
        fileTypes: 'JPG, PNG, WebP (up to 50 MB each)',
        cancel: 'Cancel',
        uploadAll: 'Upload All',
        uploading: 'Uploading...',
        errorPrefix: 'Error: ',
    },
    photoModal: {
        closeSettings: 'Close settings',
        rating: 'Rating',
        tagged: 'Tagged as',
        visibility: 'Visibility',
        visibilityPublic: 'Public',
        visibilityPrivate: 'Private',
        manageSection: 'Manage',
        makePublic: 'Make Public',
        makePrivate: 'Make Private',
        deletePhoto: 'Delete Photo',
        deletePhotoConfirmTitle: 'Delete Photo',
        deletePhotoConfirmMessage: 'This action cannot be undone. Are you sure you want to delete this photo?',
        restoreOriginal: 'Restore Original',
        restoreOriginalConfirmTitle: 'Restore Original',
        restoreOriginalConfirmMessage: 'This will replace the current photo with its pre-enhancement backup, undoing the last enhancement. Continue?',
        deleteBackup: 'Delete Backup',
        deleteBackupConfirmTitle: 'Delete Backup',
        deleteBackupConfirmMessage: 'This permanently deletes the pre-enhancement backup. The current (enhanced) photo will not be affected, and this cannot be undone. Continue?',
        hardDeletePhoto: 'Permanently Delete',
        hardDeletePhotoConfirmTitle: 'Permanently Delete Photo',
        hardDeletePhotoConfirmMessage: 'This permanently removes the photo and every file it owns from storage, including any backups. This cannot be undone. Continue?',
        generatePublicLink: 'Generate Public Link',
        copyPublicLink: 'Copy Link',
        removePublicLink: 'Remove Link',
        publicLinkCopied: 'Link copied!',
    },
    login: {
        logIn: 'Log In',
        invalid: 'Invalid!!',
    },
    changeAccessCode: {
        forcedHeading: 'You must update your access code before continuing',
        voluntaryHeading: 'Change your access code',
        currentPinLabel: 'Enter your current access code',
        newPinLabel: 'Enter your new access code',
        confirmPinLabel: 'Confirm your new access code',
        continueButton: 'Continue',
        confirmButton: 'Confirm',
        saving: 'Saving...',
        minDigitsError: 'Enter at least 4 digits.',
        mismatchError: "Codes don't match. Try again.",
        invalidCurrentPin: 'Your current PIN is incorrect.',
        invalidNewPin: 'New PIN must be 4-10 digits and different from your current PIN.',
        genericError: 'Something went wrong. Please try again.',
    },
    common: {
        loading: 'Loading...',
        error: 'Error',
        confirm: 'Confirm',
        cancel: 'Cancel',
    },
};
